import { render, staticRenderFns } from "./ReleaseDesignViewer.vue?vue&type=template&id=b7c064c0&"
import script from "./ReleaseDesignViewer.vue?vue&type=script&lang=js&"
export * from "./ReleaseDesignViewer.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDesignViewer.vue?vue&type=style&index=0&id=b7c064c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports